import { Command, Shift, ShiftData, Store, UserRole } from '@nextforce/api'
import { Text, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { ScrollView, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { HelperShiftDetails } from './helper_shift_details'
import { ManagerShiftDetails } from './manager_shift_details'
interface Props {
  shiftData?: ShiftData
  onStorePress?: (store: Store) => void
  onButtonPress(command: Command, note?: string, shift?: Shift): Promise<void>
  role: UserRole
}

export function ShiftView({
  shiftData,
  onStorePress,
  onButtonPress,
  role,
}: Props) {
  const styles = useStyles()

  if (!shiftData) {
    return <View></View>
  }

  const DetailsView =
    role === 'helper' ? HelperShiftDetails : ManagerShiftDetails

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <ScrollView
        contentContainerStyle={styles.container}
        keyboardShouldPersistTaps={'handled'}
      >
        {shiftData.statusMessages?.primary !== undefined && (
          <View>
            {shiftData.statusMessages?.primary.length ? (
              <Text style={styles.primaryStatusMessage}>
                {shiftData.statusMessages.primary}
              </Text>
            ) : null}
            {shiftData.statusMessages.secondary ? (
              <Text style={styles.secondaryStatusMessage}>
                {shiftData.statusMessages.secondary}
              </Text>
            ) : null}
          </View>
        )}

        {shiftData.shift && (
          <>
            <Text style={{ fontSize: 14, margin: 10 }}>SHIFT DETAILS</Text>
            <DetailsView
              shift={shiftData.shift}
              {...{ onButtonPress, onStorePress }}
              interests={shiftData.interests}
              candidates={shiftData.candidates}
              role={role}
            />
          </>
        )}
      </ScrollView>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.colors?.grey5,
  },

  primaryStatusMessage: {
    fontSize: 16,
    fontFamily: font.bold,
    textAlign: 'justify',
    padding: 10,
    color: theme.colors?.black,
  },
  secondaryStatusMessage: {
    fontSize: 15,
    fontFamily: font.bold,
    textAlign: 'justify',
    padding: 10,
    color: theme.colors?.grey2,
  },
}))
